import { ambientFloatLoopSkill } from './ambientFloatLoop';
import { ambientParticleFieldSkill } from './ambientParticleField';
import { atmosphereGradientFieldSkill } from './atmosphereGradientField';
import { cinematicCameraMoveSkill } from './cinematicCameraMove';
import { counterTickUpSkill } from './counterTickUp';
import { elementMorphHandoffSkill } from './elementMorphHandoff';
import { emphasisWordPulseSkill } from './emphasisWordPulse';
import { grainAndBloomSkill } from './grainAndBloom';
import { kineticWordRevealSkill } from './kineticWordReveal';
import { markerEmphasisSkill } from './markerEmphasis';
import { momentSweepTransitionSkill } from './momentSweepTransition';
import { motionPolishSkill } from './motionPolish';
import { parallaxDepthDriftSkill } from './parallaxDepthDrift';
import { splitComparisonCardsSkill } from './splitComparisonCards';
import { staggeredListRevealSkill } from './staggeredListReveal';
import { statBarsAndFillsSkill } from './statBarsAndFills';
import { svgDrawOnSkill } from './svgDrawOn';
import { svgIconEnrichmentSkill } from './svgIconEnrichment';
import { velocityMatchedCutSkill } from './velocityMatchedCut';

import type { Skill } from 'js/src/agent/skills/types';

export const HTML_DESIGN_ANIMATION_SKILLS: Skill[] = [
    counterTickUpSkill,
    statBarsAndFillsSkill,
    kineticWordRevealSkill,
    emphasisWordPulseSkill,
    markerEmphasisSkill,
    staggeredListRevealSkill,
    svgDrawOnSkill,
    svgIconEnrichmentSkill,
    ambientFloatLoopSkill,
    parallaxDepthDriftSkill,
    atmosphereGradientFieldSkill,
    ambientParticleFieldSkill,
    grainAndBloomSkill,
    motionPolishSkill,
    cinematicCameraMoveSkill,
    momentSweepTransitionSkill,
    velocityMatchedCutSkill,
    elementMorphHandoffSkill,
    splitComparisonCardsSkill,
];
